// Legacy numeric ID to emoji mapping for backward compatibility
export const LEGACY_CATEGORY_ICON_MAP: Record<string, string> = {
  '1': '🦐', '2': '🍕', '3': '🍹', '4': '🍲',
  '5': '🍚', '6': '🍜', '7': '☕', '8': '🍰', '9': '🍽️'
}

export const getCategoryEmoji = (icon?: string): string =>
  icon ? (LEGACY_CATEGORY_ICON_MAP[icon] ?? icon) : ''
